__turbopack_context__.v({
  "dark": "SearchBar-module-scss-module__3U6I6G__dark",
  "light": "SearchBar-module-scss-module__3U6I6G__light",
  "searchBar": "SearchBar-module-scss-module__3U6I6G__searchBar",
  "searchIcon": "SearchBar-module-scss-module__3U6I6G__searchIcon",
});
